<template>
  <div>
    <!-- 操作 -->
    <div class="operate">
      <!--全选  -->
      <el-checkbox v-model="$parent.checked" @change="allChecked">
        {{ $t("message.allChecked") }}
      </el-checkbox>
      <!-- 打印清单 -->
      <el-button size="small" type="success" @click="printPackingList('')">
        {{ $t("message.printPackingList") }}
      </el-button>
      <!-- 打印装箱单(无单价)-->
      <el-button size="small" type="success" @click="printPackingList('NoPrice')">
        {{ $t("message.printPackingListNoPrice") }}
      </el-button>

      <!-- 打印废弃单 -->
      <el-button size="small" type="primary" @click="abandonedList" v-if="detail.discard_status">
        {{ $t("message.abandonedList") }}
      </el-button>
      <!-- 配货打印唛头 -->
      <el-button size="small" type="primary" class="secondary " @click="shippingMarkForDistribution">
        {{ $t("message.shippingMarkForDistribution") }}
      </el-button>
      <!-- 售中问题提出 -->
      <el-button size="mini" type="primary" @click="issueSubmissionDuringSale" v-if="isAuth(621)">
        {{ $t("message.issueSubmissionDuringSale") }}
      </el-button>


      <!-- 直接付款 -->
      <el-button size="small" type="primary" class="fr" @click="balancePayPorder"
        v-if="isAuth(254) && detail.user.is_pay_authorized">
        {{ $t("message.directPayments") }}
      </el-button>
      <!-- 退回待报价 -->
      <el-button size="small" type="success" class="fr dark" @click="backToOffer" v-if="isAuth(259)">
        {{ $t("message.returnToBeQuoted") }}
      </el-button>
      <!-- 国际运费计算 -->
      <el-button size="small" type="primary" class="secondary fr" @click="InternationalFreight">
        {{ $t("message.internationalFreightCalculation") }}
      </el-button>

      <!-- 唛头打印 -->
      <div v-show="false">
        <div ref="boxshippingmark" v-if="prinData != false">
          <boxshippingmark :prinData="prinData" />
        </div>
      </div>
      <!-- 装箱打印 -->
      <div v-show="false">
        <div ref="Packinglist">
          <Packinglist :datas="item" v-for="(item, index) in PackingData" :key="index" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import boxshippingmark from "@/components/Printedsheet/boxshippingmark";
import Packinglist from '@/components/Printedsheet/Packinglist'
export default {
  components: {
    boxshippingmark,
    Packinglist,
  },
  props: {
    selectedList: { type: Array },
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      logistics_id: "",
      visible: false,
      PackingData: [],
      prinData: [],
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.porderDetail.detail,
      totalShouldPay_JPY: (state) => state.porderDetail.totalShouldPay_JPY,
      boxList: (state) => state.porderDetail.boxList,
      list: (state) => state.porderDetail.list,
    }),
  },
  mounted() {

    if (!this.list.every(item => item.inSale == false)) {
      this.$alert("当前配送单有配送单相关售中问题产品未处理完成，装箱时请注意！！！", "提醒", {
        confirmButtonText: "确定",
        center: true,
        callback: action => {
        }
      });
    }
  },
  methods: {
    //全选
    allChecked() {
      this.$emit("allChecked");
    },
    // 国际物流计算
    InternationalFreight() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.InternationalFreight.dialogVisible = true;
    },
    //退回给配货
    backToOffer() {
      this.$confirm(
        this.$t("message.isReturnToBeQuoted"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .backToOffer({ porder_sn: this.porder_sn })
            .then((res) => {
              this.$message.success(res.msg);
              this.$store.dispatch("porderDetail", {
                porder_sn: this.porder_sn,
              });
              this.$store.commit("setBoxIds", []);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 配送单付款
    balancePayPorder() {
      let datas = {
        porder_sn: this.porder_sn,
        user_id: this.detail.user_id,
        discounts_id: '',
      };
      this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - this.totalShouldPay_JPY}</b></p>
      <p> ${this.$t("message.whetherToConfirmDirectPayment")}</p>`, '直接付款', {
        confirmButtonText: '确定',
        center: true,
        dangerouslyUseHTMLString: true,
        callback: action => {
          if (action == 'confirm') {
            this.$api.clienteleApi.balancePayPorder(datas).then((res) => {
              this.$message.success(res.msg);
              setTimeout(() => {
                window.open("about:blank", "_top").close();
              }, 1000)
            });
          }
        }
      });
    },
    //配货打印唛头
    shippingMarkForDistribution() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.getMaitouData({ freightIds: this.boxIds, not_print: 1 }).then((res) => {
        res.data.forEach(item => {
          item.boxTotal = this.boxIds.length
        })
        this.prinData = res.data;
        this.$nextTick(() => {
          this.$print(this.$refs.boxshippingmark);
          this.prinData = []
        });
      });
    },
    //打印装箱单
    printPackingList(type) {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.porderApi.boxDetailBatchPrint({ freight_id_set: this.boxIds }).then(res => {
        res.data.forEach(item => {
          item.total = 0
          item.porder_freight_detail.forEach(items => {
            item.total += items.num
            if (type) {
              items.order_detail.confirm_price = ''
            }
          })
        })
        this.PackingData = res.data;
        console.log(this.PackingData);
        this.$nextTick(() => {
          this.$print(this.$refs.Packinglist);
        });
      })
    },
    //打印废弃单
    abandonedList() {
      let boxIds = []
      this.boxList.forEach(item => {
        item.group.forEach(items => {
          items.list.forEach(box => {
            boxIds.push(box.id);
          })
        })
      })
      this.$api.porderApi.discardList({ porder_sn: this.porder_sn }).then(res => {
        let itemData = res.data.data[0]
        this.$api.getMaitouData({ freightIds: boxIds }).then((res) => {
          res.data.forEach((item) => {
            item.boxTotal = boxIds.length;
            item.reason = itemData.reason
            item.created_at = itemData.created_at
            item.abandon = itemData.abandon_type == 1 ? '客户要求废弃' : '联系不上超时废弃'
            // 二维码
            this.$QRCode.toDataURL(
              item.encrypt_freight_id,
              { errorCorrectionLevel: "L", margin: 2, width: 128 },
              (err, url) => {
                if (err) throw err;
                item.QRImgUrl = url;
              }
            );
          });
          let datas = {
            logistics: '废弃',
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.$store.commit('setPrintData', datas)

          this.$nextTick(() => {
            this.$print(this.$parent.$refs.abandoned);
            this.$store.commit('setPrintData', {})
          });
        });
      })
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let ids = []
      this.selectedList.forEach(item => {
        ids.push(item.order_detail_id)
      })
      this.$parent.$refs.inSalePreview.storePreview(ids)
    },
  },
};
</script>
<style lang='scss' scoped>
.operate {
  margin: 0 24px;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;
  line-height: 32px;

  .el-button {
    margin-left: 30px;
  }
}
</style>